import IMask from 'imask';
import { Mask } from './mask';

export function clearPhone(value: string): string {
	return value.replace(/[-()\s]/g, '');
}

export function formatPhone(value: string): string {
	const phoneValue = clearPhone(value);

	let mask = IMask.createMask(Mask.International);

	if (
		phoneValue.startsWith('79') ||
		phoneValue.startsWith('+79') ||
		phoneValue.startsWith('89') ||
		phoneValue.startsWith('+89')
	) {
		mask = IMask.createMask(Mask.RU);
	}

	return mask.resolve(phoneValue);
}
